'use client';

import { Button } from '@slai/ui';
import { useTheme } from 'hooks/useTheme';
import { MoonIcon, SunIcon } from 'lucide-react';
import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};
const getClientSnapshot = () => true;
const getServerSnapshot = () => false;

export default function ThemeToggle() {
    const { setTheme, resolvedTheme } = useTheme();
    const mounted = useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);

    if (!mounted) {
        return <div className='h-8 w-8' />;
    }

    const isDark = resolvedTheme === 'dark';

    return isDark ? (
        <Button
            type='button'
            variant='ghost'
            size='sm'
            iconOnly
            icon={SunIcon}
            onClick={() => setTheme('light')}
            aria-label='Switch to light mode'
        />
    ) : (
        <Button
            type='button'
            variant='ghost'
            size='sm'
            iconOnly
            icon={MoonIcon}
            onClick={() => setTheme('dark')}
            aria-label='Switch to dark mode'
        />
    );
}
